export const advancedCitationSchema = (props) => {
  const { intl, schema } = props;

  return {
    ...schema,
    fieldsets: [
      ...schema.fieldsets,
      {
        id: 'citationOptions',
        title: intl.formatMessage({ id: 'Citation options', defaultMessage: 'Citation options' }),
        fields: ['effectiveDate', 'showRecurrence'],
      },
    ],
    properties: {
      ...schema.properties,
      effectiveDate: {
        title: intl.formatMessage({ id: 'Show date', defaultMessage: 'Show date' }),
        type: 'boolean',
        default: true,
      },
      showRecurrence: {
        title: intl.formatMessage({ id: 'Show recurrence', defaultMessage: 'Show recurrence' }),
        type: 'boolean',
      },
    },
  };
};
